<button type="button" class="nb-toggle" :aria-pressed="modelValue" @click="toggle">
  <span v-if="label" class="label">{{ label }}</span>

  <span class="switch" :class="{ active: modelValue }" :aria-checked="modelValue">
    <span class="circle"></span>
  </span>
</button>
